import React from 'react';
import { Link } from 'react-router-dom';
import { Play, CheckCircle } from 'lucide-react';
import { aboutContent, firmInfo } from '../../data/mockData';
import { Button } from '../ui/button';

const AboutSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Welcome to <span className="text-blue-900">{firmInfo.name}</span>
          </h2>
        </div>

        {/* Video Thumbnails */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="group relative overflow-hidden rounded-xl cursor-pointer shadow-lg">
            <img
              src={aboutContent.whyChooseUsImage}
              alt="Why Choose Us"
              className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-blue-900/70 flex items-center justify-center transition-opacity duration-300 group-hover:bg-blue-900/60">
              <div className="text-center">
                <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 shadow-lg">
                  <Play className="w-8 h-8 text-blue-900 ml-1" />
                </div>
                <h3 className="text-xl font-bold text-white">WHY CHOOSE US</h3>
              </div>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-xl cursor-pointer shadow-lg">
            <img
              src={aboutContent.whatToExpectImage}
              alt="What to Expect"
              className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-blue-900/70 flex items-center justify-center transition-opacity duration-300 group-hover:bg-blue-900/60">
              <div className="text-center">
                <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mx-auto mb-4 transition-transform duration-300 group-hover:scale-110 shadow-lg">
                  <Play className="w-8 h-8 text-blue-900 ml-1" />
                </div>
                <h3 className="text-xl font-bold text-white">WHAT TO EXPECT</h3>
              </div>
            </div>
          </div>
        </div>

        {/* About Content */}
        <div className="max-w-4xl mx-auto">
          <p className="text-gray-600 text-lg leading-relaxed mb-6">
            {aboutContent.mainText}
          </p>
          
          <p className="text-blue-900 text-xl font-semibold mb-6 border-l-4 border-amber-500 pl-4 bg-blue-50 py-4 rounded-r-lg">
            {aboutContent.highlight}
          </p>

          <p className="text-gray-600 text-lg leading-relaxed mb-8">
            {aboutContent.secondaryText}
          </p>

          {/* Key Points */}
          <div className="grid sm:grid-cols-2 gap-4 mb-8">
            {[
              'Over 40 years of trial experience',
              'No fee unless we win your case',
              'We come to you',
              'Handled over 10,000 cases',
              'Fighting for the injured',
              '24/7 Free consultation'
            ].map((point, index) => (
              <div key={index} className="flex items-center gap-3">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700">{point}</span>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Button
              asChild
              size="lg"
              className="bg-blue-900 hover:bg-blue-800 text-white font-bold px-8 py-6 text-lg rounded-md transition-all duration-300 hover:shadow-lg"
            >
              <Link to="/about">Read More</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
